import { Component, Inject } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { BookingEventDeprecated } from "@hermes/api-model-editorial";

import { CHAPTERS_PARAGRAPH } from "../../core";

@Component({
    selector: "h-booking-event",
    templateUrl: "./booking-event.component.html",
    styleUrls: ["./booking-event.component.scss"],
    standalone: false,
})
export class BookingEventComponent {
    public iframeUrl: SafeResourceUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(
            `${this.bookingEvent.link}?embedded=true&lang=${
                this.bookingEvent.lang
            }&disable_ga=true${this.bookingEvent.parameters ?? ""}`,
        );
    constructor(
        @Inject(CHAPTERS_PARAGRAPH) public bookingEvent: BookingEventDeprecated,
        private sanitizer: DomSanitizer,
    ) {}
}
